import Form from "./components/Form";
import { GetUserData } from "./data/GetUserData";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route} from 'react-router-dom'


function App() {
  const [data, setData] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      setData(await GetUserData())
    } 
    fetchData()
  }, []) 


 

  return data && ( 
 
  <BrowserRouter>
  <Routes>
      <Route path="/" element={<Form preloadedValues={data}/>}></Route> 
      <Route path="*" element={<Form preloadedValues={data}/>}></Route> 
  </Routes>
  </BrowserRouter>
  )
  
  
}

export default App;